export const  soilTypes = [
    { id: 1, type: "Purnell", grade: "A", depth: '8-16"' },
    { id: 2, type: "Mispillion / Pawcatuck", grade: "A", depth: '16-51"' },
    { id: 3, type: "Boxiron", grade: "B", depth: '8-16"' },
    { id: 4, type: "Honga", grade: "B", depth: '16-51"' },
    { id: 5, type: "Bestpitch", grade: "C", depth: '16-51"' },
    { id: 6, type: "Broadkill / Appoquinimink", grade: "C", depth: '<8"' },
    { id: 7, type: "Transquaking", grade: "C", depth: '>51"' },
    // { id: 8, type: "collect soil at a different depth", grade: "C", depth: '8-16"' },
  ];